/**
 * The AI window: let an AI service of your choice describe nodes, propose groups or review
 * the architecture.
 *
 * - `ServiceSection.tsx`: which service (OpenAI, Anthropic, Mistral, a local Ollama…), the
 *   model and the API key (kept by the core, never shown again); Save and Test.
 * - `TasksSection.tsx`: Write notes, Propose groups, Review.
 * - `SuggestionsSection.tsx`: what the AI suggested, each with a checkbox; Apply makes the kept
 *   ones one undoable edit. Node chips select and centre the node on the graph.
 *
 * Everything goes through the AI service (`state/ai.ts`), which keeps the suggestions when the
 * window is moved or closed.
 */
import type { JSX } from "solid-js";
import { ServiceSection } from "./ServiceSection";
import { SuggestionsSection } from "./SuggestionsSection";
import { TasksSection } from "./TasksSection";

/** The AI window. */
export function AiWindow(): JSX.Element {
  return (
    <div class="aiwin">
      <ServiceSection />
      <TasksSection />
      <SuggestionsSection />
    </div>
  );
}
